module.exports = __webpack_public_path__ + "static/zircon-heart-ring-10k-yellow-gold-diamond2-00f8ac3566c58c8f75060dcac3d58c37.jpg";